import { render, staticRenderFns } from "./PPCInputApproval.vue?vue&type=template&id=8957e07e&scoped=true&"
import script from "./PPCInputApproval.vue?vue&type=script&lang=js&"
export * from "./PPCInputApproval.vue?vue&type=script&lang=js&"
import style0 from "../InputPPM/InputPPM.scss?vue&type=style&index=0&id=8957e07e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8957e07e",
  null
  
)

export default component.exports